import React from 'react';
import { 
  Paper, 
  Group, 
  Stack, 
  Text, 
  Divider,
  Box
} from '@mantine/core';
import { ImageDetails } from '../../../../../types/Image';

interface ExifDataSectionProps {
  metadata: ImageDetails;
}

export const ExifDataSection: React.FC<ExifDataSectionProps> = ({ metadata }) => {
  return (
    <Stack gap={0}>
      <Text fw={500} size={'sm'}>EXIF Data</Text>
      <Paper mt={5} withBorder radius="sm" style={{overflow: 'hidden'}}>
        <Group justify="space-between" align="center" px="xs" py={4} bg="gray.1">
          <Text size="sm">{metadata.camera?.model || 'Unknown Camera'}</Text>
          <Text fw={500} size="sm" tt="uppercase">{metadata.file?.type || 'Unknown'}</Text>
        </Group>
        <Divider mb={0}/>

        {metadata.camera?.model && (
          <>
            <Box p="xs">
              <Text size="sm" truncate>{metadata.camera?.lens || 'Unknown lens'}</Text>
              <Group wrap="nowrap">
                <Text size="sm" c="dimmed">ISO {metadata.camera?.iso || 'Unknown'}</Text>
                <Text size="sm" c="dimmed">•</Text>
                <Text size="sm" c="dimmed">{metadata.camera?.focal_length || 'Unknown'}</Text>
                <Text size="sm" c="dimmed">•</Text>
                <Text size="sm" c="dimmed">ƒ/{metadata.camera?.aperture || 'Unknown'}</Text>
                <Text size="sm" c="dimmed">•</Text>
                <Text size="sm" c="dimmed">{metadata.camera?.exposure || 'Unknown'}s</Text>
              </Group>
            </Box>
            <Divider mb={0}/>
          </>
        )}

        <Group justify="center" wrap="nowrap" style={{ minWidth: 0, overflow: 'hidden' }}>
          <Text size="xs" ta="center" c="grey" truncate>{Math.round((metadata.file?.width || 0) * (metadata.file?.height || 0) / 1000000)} MP</Text>
          <Divider orientation="vertical"/>
          <Text size="xs" ta="center" c="grey" truncate>{metadata.file?.width || 0} x {metadata.file?.height || 0}</Text>
          <Divider orientation="vertical"/>
          <Text size="xs" ta="center" c="grey" truncate>{`${metadata.file?.width || 0}:${metadata.file?.height || 0}`.replace(':', ' : ')}</Text>
          <Divider orientation="vertical"/>
          <Text size="xs" ta="center" c="grey" truncate>{metadata.file?.size ? `${Math.round(metadata.file.size / 1024)} KB` : 'Unknown'}</Text>
        </Group>
      </Paper>
    </Stack>
  );
};
